// extracted by mini-css-extract-plugin
module.exports = {"FormNavigation":"styles_FormNavigation__1bzrB"};